import clsx from 'clsx';
import { useRef } from 'react';
import { WaterMark } from '../../assets/water-mark';
import { useEditorNet } from '../../hooks/use-editor-net';
import styles from './editor-wrapper.module.css';
import { EditorWrapperProps } from './editor-wrapper.props';

export const EditorWrapper = ({ children, className, ...props }: EditorWrapperProps) => {
	const editorRef = useRef<HTMLDivElement>(null);
	const { horizontalLines, verticalLines, waterMarks } = useEditorNet(editorRef);

	return (
		<div ref={editorRef} className={clsx(styles.wrapper, className)} {...props}>
			<div className={styles.contentWrapper}>{children}</div>
			<div className={styles.netWrapper}>
				{horizontalLines.map((line) => (
					<div
						key={line.key}
						style={{ top: line.top }}
						className={clsx(styles.horizontalLine, styles.line, {
							[styles.bold]: line.bold,
						})}
					/>
				))}
				{verticalLines.map((line) => (
					<div
						key={line.key}
						style={{ left: line.left }}
						className={clsx(styles.verticalLine, styles.line, {
							[styles.bold]: line.bold,
						})}
					/>
				))}
				{waterMarks.map((mark) => (
					<div
						key={mark.key}
						className={styles.waterMarkWrapper}
						style={{ top: mark.top, left: mark.left }}
					>
						<WaterMark className={styles.waterMark} />
					</div>
				))}
			</div>
		</div>
	);
};
